'use client'

import { Col, CopyButton, Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'

interface WithNumberOutputItemProps {
  title: string
  value: string
  isCopyable?: boolean
  description?: string
}

export const AccountToAccountOutputItem = ({
  title,
  value,
  description,
  isCopyable = true,
}: WithNumberOutputItemProps) => {
  const { t } = useTranslate()

  return (
    <Col className='gap-2xs'>
      <Typography size='xs' weight='bold' color='text-neutral-surface-100'>
        {title}
      </Typography>

      <Row className='gap-md justify-between border border-neutral-surface-dark rounded-xs min-h-10 py-xs md:py-2xs  ps-md pe-2xs'>
        <Typography size='md' color='text-neutral-surface-100'>
          {value}
        </Typography>
        {isCopyable && (
          <CopyButton
            text={value ?? ''}
            nonActiveTitle={t('common_copy')}
            activeMessageTitle={t('common_copied')}
          />
        )}
      </Row>
      {description && (
        <Typography size='xs' color='text-neutral-surface-100'>
          {description}
        </Typography>
      )}
    </Col>
  )
}
